import { Link } from 'react-router-dom'
import { FaTwitter } from 'react-icons/fa'
import logo from '../images/logo.png'

const Header = () => {
  return (
    <>
      <header className="absolute w-full flex items-center justify-between py-2 px-5 text-white xl:px-32">
        <Link to="/">
          <div className="logo">
            <img
              src={logo}
              alt="Amgel Enterprises Limited"
              title="Amgel"
              className="w-16"
            />
          </div>
        </Link>

        <nav className="flex flex-col">
          <ul className="flex">
            <li className="mr-5 text-lg">
              <Link to="/">Home</Link>
            </li>
            {/* <li className="mr-5 text-lg">
              <Link to="/about">About</Link>
            </li>
            <li className="mr-5 text-lg">
              <Link to="/services">Services</Link>
            </li> */}
            <li className="mr-5 text-lg">
              <Link to="/routes">Routes</Link>
            </li>
            <li>
              <a
                href="#footer"
                className="bg-green-600 py-1 px-2 rounded transition-colors hover:bg-green-500"
              >
                Contact
              </a>
            </li>
            {/* <li className="mr-5 text-lg">
              <Link to="/timeline">Timeline</Link>
            </li>
            <li className="mr-5 text-lg">
              <Link to="/contacts">Contacts</Link>
            </li>
            <li className="mr-5 text-lg">
              <Link to="/deliveries">Deliveries</Link>
            </li> */}
          </ul>

          <ul className="flex mt-3 justify-end">
            {/* <li className="mr-5 text-xl">
              <a href="#">
                <GrFacebook />
              </a>
            </li> */}
            <li className="mr-5 text-xl">
              <a
                href="https://twitter.com/AmgelInnocent"
                target="_blank"
                rel="noopenner noreferrer"
              >
                <FaTwitter />
              </a>
            </li>
            {/* <li className="mr-5 text-xl">
              <a href="#">
                <FaInstagram />
              </a>
            </li>
            <li className="mr-5 text-xl">
              <Link to="/location">
                <HiLocationMarker />
              </Link>
            </li> */}
          </ul>
        </nav>
      </header>
    </>
  )
}

export default Header
